import script from "./UiAdminForm.vue?vue&type=script&setup=true&lang=js"
export * from "./UiAdminForm.vue?vue&type=script&setup=true&lang=js"

import "./UiAdminForm.vue?vue&type=style&index=0&id=f07e8760&lang=scss"

const __exports__ = script;

export default __exports__